module.exports = __webpack_public_path__ + "static/media/Prosper-Card-Back.dc8f5401.png";